import { AutogenLayoutDuplicateOrderPrompt } from "./autogen/AutogenLayoutDuplicateOrderPrompt";

export class DuplicateOrderPrompt extends AutogenLayoutDuplicateOrderPrompt {
}
